import CurrentTierCredits, {
  CurrentTierCreditsProps,
} from './CurrentTierCredits';

export type {CurrentTierCreditsProps};
export default CurrentTierCredits;
